<template>
  <div>
    <div class="header-container" :class="{ 'header-fixed': isFixed, 'detail-mode': detailMode }" ref="headerRoot">
      <div class="logo-area">
        <div class="logo-area-left animate-scroll" @click="goToHome">
          <img :src="getLogoSource()" alt="闻讼咨询" class="logo animate">
        </div>
        <div class="logo-area-right animate-scroll">
          <img :src="getMenuIconSource()" alt="菜单" class="menu-icon" @click="toggleDrawer">
        </div>
      </div>

      <!-- 侧边抽屉菜单 -->
      <transition name="drawer">
        <div v-if="isDrawerOpen" class="drawer-overlay" @click="closeDrawer">
          <div class="drawer" @click.stop>
            <!-- 关闭按钮 -->
            <div class="drawer-header">
              <img src="@/assets/image/logo-white@2x.png" alt="闻讼咨询" class="drawer-logo">
              <div class="dismiss-icon" @click="closeDrawer">×</div>
            </div>
            <!-- 菜单内容 -->
            <div class="drawer-content">
              <nav class="menu-list">
                <router-link to="/" class="menu-item" @click="closeDrawer">首页</router-link>
                <router-link to="/about" class="menu-item" @click="closeDrawer">走进闻讼</router-link>
                <router-link to="/business" class="menu-item" @click="closeDrawer">大型企业诉管服务</router-link>
<!--                <router-link to="/lawyers" class="menu-item" @click="closeDrawer">闻讼认证律师</router-link>-->
                <!-- <router-link to="/knowledge" class="menu-item" @click="closeDrawer">闻讼知识库</router-link> -->
                <router-link to="/overseas" class="menu-item" @click="closeDrawer">涉外服务</router-link>
                <router-link to="/cooperation" class="menu-item" @click="closeDrawer">商务合作</router-link>
                <router-link to="/join" class="menu-item" @click="closeDrawer">加入闻讼</router-link>
              </nav>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 占位符，防止内容被固定头部遮挡 -->
    <div class="header-placeholder"></div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    // 详情页模式：使用彩色logo，白色背景
    detailMode: {
      type: Boolean,
      default: false
    },
    // 强制使用彩色logo（用于详情页）
    forceColorLogo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDrawerOpen: false,
      observer: null,
      isFixed: false,
      scrollThreshold: 50, // 降低滚动阈值，让头部更快固定
      scrollTimeout: null,
      lastScrollTop: 0 // 记录上一次滚动位置
    }
  },
  mounted() {
    this.initScrollAnimations();
    this.initScrollListener();
    
    // 为了修复页面初始加载时的问题
    this.$nextTick(() => {
      // 初始检查滚动位置
      this.handleScroll();
      
      // 强制重新计算样式，防止闪烁
      setTimeout(() => {
        this.handleScroll();
      }, 100);
    });
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.removeScrollListener();
    // 清理定时器
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = null;
    }
  },
  methods: {
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
      document.body.style.overflow = this.isDrawerOpen ? 'hidden' : '';
    },
    closeDrawer() {
      this.isDrawerOpen = false;
      document.body.style.overflow = '';
    },
    initScrollAnimations() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      const section = this.$refs.headerRoot;
      if (section && section instanceof Element) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const animatedElements = entry.target.querySelectorAll('.animate-scroll');
              animatedElements.forEach(el => {
                el.classList.add('visible');
              });
            }
          });
        }, options);
        this.observer.observe(section);
      }
    },
    initScrollListener() {
      window.addEventListener('scroll', this.handleScroll);
      
      // 添加调整大小的监听，以便在窗口调整大小时更新
      window.addEventListener('resize', this.handleScroll);
    },
    removeScrollListener() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    },
    handleScroll() {
      // 使用节流优化性能
      if (this.scrollTimeout) {
        return;
      }
      
      this.scrollTimeout = setTimeout(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const newFixed = scrollTop > this.scrollThreshold;
        
        // 只有当状态实际改变时才更新
        if (this.isFixed !== newFixed) {
          this.isFixed = newFixed;
        }
        
        this.lastScrollTop = scrollTop;
        this.scrollTimeout = null;
      }, 10); // 10ms的节流
    },
    getLogoSource() {
      // 详情页模式或强制彩色logo时，始终使用彩色logo
      if (this.detailMode || this.forceColorLogo) {
        return require('@/assets/image/colorLogo@2x.png');
      }
      // 普通模式：根据固定状态切换
      return this.isFixed ? require('@/assets/image/colorLogo@2x.png') : require('@/assets/image/logo-white@2x.png');
    },
    getMenuIconSource() {
      // 详情页模式：根据固定状态切换菜单图标
      if (this.detailMode) {
        return this.isFixed ? require('@/assets/image/menu.png') : require('@/assets/image/menu.png');
      }
      // 普通模式：根据固定状态切换
      return this.isFixed ? require('@/assets/image/menu.png') : require('@/assets/image/menu-white.png');
    },
    goToHome() {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.header-placeholder {
  height: 80px; /* 与header高度相同 */
}

.header-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 80px; /* 固定高度 */
  transition: background-color 0.4s ease, box-shadow 0.4s ease;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center; /* 水平居中 */
}

.header-container.header-fixed {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.logo-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  /* padding: 0 15px; */
}

.logo {
  width: 109px;
  height: 40px;
  transition: all 0.3s ease;
}
.logo-area-right {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}
.menu-icon {
  width: 24px;
  height: 24px;
  margin-left: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* 动画样式 */
.animate-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;
}
.animate-scroll.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 详情页模式样式 */
.header-container.detail-mode {
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.header-container.detail-mode.header-fixed {
  background-color: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
}

.header-container.detail-mode .logo-area {
  justify-content: space-between; /* 恢复两端对齐布局 */
}

/* 抽屉遮罩层 */
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

/* 抽屉样式 */
.drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 500px;
  height: 899px;
  /* background: #1B2038; */
  background-image: url('~@/assets/image/header-drawer-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* border: 1px solid #979797; */
  z-index: 1001;
}

/* 抽屉头部 */
.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 100px 40px;
  text-align: right;
  
  .drawer-logo {
    width: 109px;
    height: 40px;
  }
  
  .dismiss-icon {
    color: rgb(255, 255, 255);
    cursor: pointer;
    background-color: transparent;
    border: none;
    font-size: 36px;
  }
}

.close-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

/* 抽屉内容 */
.drawer-content {}

.menu-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 30px 0 0 40px;
}

.menu-item {
  color: #FFFFFF;
  font-size: 26px;
  text-decoration: none;
  transition: color 0.3s ease;
}

.menu-item:hover {
  color: #3578E5;
}

/* 抽屉过渡动画 */
.drawer-enter-active,
.drawer-leave-active {
  transition: opacity 0.3s ease;
}

.drawer-enter-active .drawer,
.drawer-leave-active .drawer {
  transition: transform 0.3s ease;
}

.drawer-enter-from,
.drawer-leave-to {
  opacity: 0;
}

.drawer-enter-from .drawer,
.drawer-leave-to .drawer {
  transform: translateX(100%);
}

.drawer-enter-to,
.drawer-leave-from {
  opacity: 1;
}

.drawer-enter-to .drawer,
.drawer-leave-from .drawer {
  transform: translateX(0);
}
</style>
